import React from "react";
import { useInView } from 'react-intersection-observer';

const CTAStyles = {
  container: "flex flex-col justify-center items-center ",
  box: "flex flex-col px-6 md:px-0 md:w-full items-center justify-center space-y-12 py-10 h-[400px] bg-[#f7f9fd] ",
  box__div: "flex flex-col items-center justify-center space-y-6",
  box__div__p: "font-inter text-md font-bold text-indigo-800",
  box__div__h3:
    "font-inter text-3xl text-center md:text-4xl font-semibold text-indigo-900",
  box__p:
    "text-lg md:text-xl text-center font-inter font-semibold md:w-[450px] text-[#8696ae]",
  card: "flex w-[370px] md:w-[1200px]",
};

const DetailsSection = () => {
  const [detailsRef, inViewDetails] = useInView({
    triggerOnce: true, // Trigger the animation only once
    threshold: 0.5, // Adjust the threshold as needed
  });

  return (
    <section ref={detailsRef} className="flex flex-col lg:flex-row  items-center  lg:h-[300px] bg-black/80  ">
      <div className={`flex flex-col px-6  space-y-12 py-10  bg-black/20  h-full w-full items-center lg:items-start md:pl-10  lg:w-1/2 lg:pl-20 ${inViewDetails ? 'animate-slideInFromLeft transition duration-500 ease-in' :''} `}>
        <div className="flex flex-col justify-center space-y-6">
          <h3 className="font-inter text-3xl text-center lg:text-left font-semibold text-white">
            Fast & reliable execution
          </h3>
          <p className="text-lg md:text-xl text-center lg:text-left  font-inter font-normal md:w-[450px] text-gray-300">
            With free VPS hosting
          </p>
        </div>
        <a
          href="#"
          className="text-sm md:text-lg font-normal text-[#07f2c7] hover:underline underline-offset-4"
        >
          See VPS Details
        </a>
      </div>
      <div className={`flex flex-col px-6   space-y-12 py-10  bg-black/50  h-full w-full items-center lg:items-start md:pl-10   lg:w-1/2 lg:pl-20 ${inViewDetails ? 'animate-slideInFromRight transition duration-500 ease-in' :''} `}>
        <div className="flex flex-col justify-center space-y-6">
          <h3 className="font-inter text-3xl text-center lg:text-left font-semibold text-white">
          Transparent price history
          </h3>
          <p className="text-lg md:text-xl text-center lg:text-left  font-inter font-normal md:w-[450px] text-gray-300">
          Tick-level data across all instruments
          </p>
        </div>
        <a
          href="#"
          className="text-sm md:text-lg font-normal text-[#07f2c7] hover:underline underline-offset-4"
        >
          See Price history
        </a>
      </div>
      
    </section>
  );
};

export default DetailsSection;
